import { Controller } from "@hotwired/stimulus"

// Filters the chat switcher dropdown. A search field appears once the list is
// long enough that scanning by eye is awkward; below that threshold the menu
// stays a plain list.
export default class extends Controller {
  static targets = ["search", "searchInput", "row", "empty"]

  // Show the search field once the switcher has this many chats (or more).
  static SEARCH_THRESHOLD = 8

  connect() {
    this.onShown = this.onShown.bind(this)
    this.onHidden = this.onHidden.bind(this)
    this.element.addEventListener("dropdown:shown", this.onShown)
    this.element.addEventListener("dropdown:hidden", this.onHidden)
    this.updateSearchVisibility()
  }

  disconnect() {
    this.element.removeEventListener("dropdown:shown", this.onShown)
    this.element.removeEventListener("dropdown:hidden", this.onHidden)
  }

  onShown() {
    this.updateSearchVisibility()
    this.filter()
    if (this.hasSearchInputTarget && this.hasSearchTarget
        && !this.searchTarget.classList.contains("hidden")) {
      this.searchInputTarget.focus()
      this.searchInputTarget.select()
    }
  }

  onHidden() {
    if (this.hasSearchInputTarget) this.searchInputTarget.value = ""
    this.filter()
  }

  filter() {
    const query = this.hasSearchInputTarget
      ? this.searchInputTarget.value.trim().toLowerCase()
      : ""
    let visible = 0

    this.rowTargets.forEach((row) => {
      const title = (row.dataset.title || row.textContent || "").toLowerCase()
      const match = !query || title.includes(query)
      row.classList.toggle("hidden", !match)
      if (match) visible++
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visible > 0 || this.rowTargets.length === 0)
    }
  }

  updateSearchVisibility() {
    if (!this.hasSearchTarget) return
    const show = this.rowTargets.length >= this.constructor.SEARCH_THRESHOLD
    this.searchTarget.classList.toggle("hidden", !show)
  }

  // Stop Escape from also minimizing the dock while the search field is focused.
  onSearchKeydown(event) {
    if (event.key !== "Escape") return
    event.preventDefault()
    event.stopPropagation()
    if (this.searchInputTarget.value) {
      this.searchInputTarget.value = ""
      this.filter()
      return
    }
    // Empty search: close the dropdown via its own Escape handling on document.
    document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", bubbles: true }))
  }
}
